import JsBarcode from "jsbarcode";

const rand = (v) => "R " + (Number(v) || 0).toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ",");
const fmtDate = (iso) => {
  try {
    return new Date(iso).toLocaleDateString("en-ZA", { day: "2-digit", month: "short", year: "numeric" });
  } catch {
    return iso || "";
  }
};

const barcodeSvg = (code) => {
  const svg = document.createElementNS("http://www.w3.org/2000/svg", "svg");
  try {
    JsBarcode(svg, code, { format: "CODE128", width: 2, height: 60, displayValue: true, fontSize: 16, margin: 0 });
  } catch (e) {
    return "";
  }
  return svg.outerHTML;
};

const esc = (s) => String(s ?? "").replace(/[&<>"']/g, (c) => ({ "&": "&amp;", "<": "&lt;", ">": "&gt;", '"': "&quot;", "'": "&#39;" }[c]));

// 80mm thermal slip for a prepaid gift voucher (or its remaining balance).
export function printGiftVoucherSlip(v, store = {}) {
  if (!v?.code) return;
  const storeName = esc(store.company_name || "BOSVELD BOU & HARDWARE");
  store = { ...store, company_address: esc(store.company_address), company_contact: esc(store.company_contact) };
  v = { ...v, buyer_name: esc(v.buyer_name), cashier: esc(v.cashier), code: esc(v.code) };
  const html = `<!doctype html><html><head><meta charset="utf-8"><title>Gift Voucher ${v.code}</title>
<style>
  @page { size: 80mm auto; margin: 0; }
  body { width: 80mm; margin: 0; padding: 4mm 3mm 8mm; font-family: 'Courier New', monospace; font-size: 13px; font-weight: 700; line-height: 1.45; color: #000; }
  .c { text-align: center; } .big { font-size: 18px; font-weight: 900; }
  .value { font-size: 34px; font-weight: 900; margin: 6px 0; }
  hr { border: 0; border-top: 2px dashed #000; margin: 6px 0; }
  .box { border: 3px solid #000; padding: 6px 4px; margin: 8px 0; text-align: center; }
  .box svg { max-width: 100%; }
  .kv { display: flex; justify-content: space-between; }
</style></head><body>
  <div class="c big">${storeName}</div>
  ${store.company_address ? `<div class="c" style="font-size:12px">${store.company_address}</div>` : ""}
  ${store.company_contact ? `<div class="c" style="font-size:12px">${store.company_contact}</div>` : ""}
  <hr>
  <div class="c big">GIFT VOUCHER</div>
  <div class="c value">${rand(v.balance ?? v.initial_value)}</div>
  ${v.balance != null && v.initial_value && v.balance < v.initial_value ? `<div class="c">Remaining balance of ${rand(v.initial_value)} voucher</div>` : ""}
  <div class="box">${barcodeSvg(v.code)}</div>
  <div class="kv"><span>Valid until:</span><span>${fmtDate(v.expires_at)}</span></div>
  <div class="kv"><span>Issued:</span><span>${fmtDate(v.created_at)}</span></div>
  ${v.buyer_name ? `<div class="kv"><span>For:</span><span>${v.buyer_name}</span></div>` : ""}
  ${v.cashier ? `<div class="kv"><span>Cashier:</span><span>${v.cashier}</span></div>` : ""}
  <hr>
  <div class="c">Spend in store on any purchase.<br>Use in parts &mdash; the balance stays on the voucher.<br>Treat like cash: keep this slip safe.</div>
</body></html>`;

  const frame = document.createElement("iframe");
  Object.assign(frame.style, { position: "fixed", right: "0", bottom: "0", width: "0", height: "0", border: "0" });
  document.body.appendChild(frame);
  const doc = frame.contentWindow.document;
  doc.open();
  doc.write(html);
  doc.close();
  setTimeout(() => {
    try {
      frame.contentWindow.focus();
      frame.contentWindow.print();
    } catch (e) {
      console.error("Gift voucher print failed:", e);
    }
    setTimeout(() => frame.parentNode && frame.parentNode.removeChild(frame), 2000);
  }, 250);
}
